export default class notificationForm {
    private readonly notificationForm: HTMLFormElement;
    private readonly myDocuments: HTMLDivElement|null;

    private readonly myDocumentsSubscribe: HTMLAnchorElement|null;
    private readonly myDocumentsUnsubscribe: HTMLAnchorElement|null;

    constructor() {
        const notificationForm = <HTMLFormElement|null>document.getElementById('notification-preferences-form');

        if(!(notificationForm instanceof HTMLFormElement)) {
            return;
        }

        this.notificationForm = notificationForm;
        this.myDocuments = <HTMLDivElement>document.getElementById('mydocs-form');

        this.myDocumentsSubscribe = <HTMLAnchorElement>document.getElementById('notification-preference-window__subscribe');
        this.myDocumentsUnsubscribe = <HTMLAnchorElement>document.getElementById('notification-preference-window__unsubscribe');

        this.updateMyDocumentsCounter();
        this.bindActions();
    }

    toggleFolder(folderToggle: HTMLDivElement, displayValue: string = 'block', hiddenValue: string = 'none'): void {
        const folder = <HTMLLIElement|null>folderToggle.parentNode;

        if(folder === null) {
            return;
        }

        let folderItems = folder.querySelectorAll<HTMLUListElement>('& > .directory-notification-tree');

        folderItems.forEach((e) => {
            if(e.style.display !== displayValue) {
                e.style.display = displayValue;
                return;
            }

            e.style.display = hiddenValue;
        });

        let backgroundImage: string = folderToggle.style.backgroundImage;
        if(backgroundImage === '' || backgroundImage === 'url("/images/arrow-right-s-line.svg")') {
            folderToggle.style.backgroundImage = 'url("/images/arrow-down-s-line.svg")';
            return;
        }

        folderToggle.style.backgroundImage = 'url("/images/arrow-right-s-line.svg")';
    }

    updateMyDocumentsCounter(inputs: NodeListOf<HTMLInputElement>|null=null): void {
        if(inputs === null) {
            if(this.myDocuments) {
                inputs = <NodeListOf<HTMLInputElement>>this.myDocuments.querySelectorAll('input[type=checkbox]');
            } else {
                return;
            }
        }

        if(inputs.length === 0) {
            return;
        }

        let checkCounter = <HTMLParagraphElement>this.myDocuments?.querySelector('#notification-preference-window__check-counter');

        let total: number = inputs.length;
        let checked: number = 0;

        inputs.forEach((e) => {
            if(e.checked === true) {
                checked++;
            }
        });

        checkCounter.innerHTML = `${checked} of ${total} selected`;
    }

    bindActions(): void {
        if(this.myDocumentsSubscribe) {
            this.myDocumentsSubscribe.addEventListener('click', () => {
                this.setCheckedForMyDocuments(true);
            });
        }

        if(this.myDocumentsUnsubscribe) {
            this.myDocumentsUnsubscribe.addEventListener('click', () => {
                this.setCheckedForMyDocuments(false);
            });
        }

        if(this.myDocuments) {
            this.myDocuments.addEventListener('click', (e) => {
                const target = e.target;

                if(target instanceof HTMLInputElement) {
                    this.updateMyDocumentsCounter();
                    return;
                }

                if(!(target instanceof HTMLDivElement)) {
                    return;
                }

                if(Array.from(target.classList).includes('directory-notification-tree__toggle')) {
                    this.toggleFolder(target);
                }
            })
        }
    }

    setCheckedForMyDocuments(enabled: boolean): void {
        if(this.myDocuments === null) {
            return
        }

        const inputs = <NodeListOf<HTMLInputElement>>this.myDocuments.querySelectorAll('input[type=checkbox]');

        if(!inputs.length) {
            return;
        }

        Array.from(inputs).forEach((checkBox => {
            checkBox.checked = enabled;
        }));

        this.updateMyDocumentsCounter(inputs);
    }
}
